import { render, staticRenderFns } from "./ModalSuccessDeleteKonten.vue?vue&type=template&id=6aa21cee&"
import script from "./ModalSuccessDeleteKonten.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessDeleteKonten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports